import { render, staticRenderFns } from "./BuildList.vue?vue&type=template&id=3858447a&scoped=true&"
import script from "./BuildList.vue?vue&type=script&lang=js&"
export * from "./BuildList.vue?vue&type=script&lang=js&"
import style0 from "./BuildList.vue?vue&type=style&index=0&id=3858447a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3858447a",
  null
  
)

export default component.exports